var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSmartGatewayIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 119,
    height: 120,
    viewBox: "0 0 119 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M88.8935 6H29.6838C16.6036 6 6 16.7064 6 29.9134V89.697C6 102.904 16.6036 113.61 29.6838 113.61H88.8935C101.974 113.61 112.577 102.904 112.577 89.697V29.9134C112.577 16.7064 101.974 6 88.8935 6Z",
    fill: "transparent",
    stroke: "#534545",
    strokeWidth: 11,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M60.5 88C66.299 88 71 83.299 71 77.5C71 71.701 66.299 67 60.5 67C54.701 67 50 71.701 50 77.5C50 83.299 54.701 88 60.5 88Z",
    fill: "black"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M37 60.0877C39.7688 56.2847 43.1594 53.2424 46.9504 51.1595C50.7413 49.0766 54.8473 48 59 48C63.1527 48 67.2587 49.0766 71.0496 51.1595C74.8406 53.2424 78.2312 56.2847 81 60.0877L74.7167 67C72.739 64.2835 70.3171 62.1103 67.6092 60.6225C64.9013 59.1346 61.9684 58.3655 59.0021 58.3655C56.0358 58.3655 53.1029 59.1346 50.395 60.6225C47.6872 62.1103 45.2652 64.2835 43.2875 67L37 60.0877Z",
    fill: "black"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M21 50.0703C25.4256 44.4594 31.1632 39.9056 37.7586 36.7692C44.3541 33.6328 51.6265 32 59 32C66.3735 32 73.6459 33.6328 80.2414 36.7692C86.8369 39.9056 92.5744 44.4594 97 50.0703L90.0909 55C86.471 50.4073 81.7766 46.6796 76.3798 44.1121C70.983 41.5447 65.0318 40.208 58.9978 40.208C52.9638 40.208 47.0127 41.5447 41.6159 44.1121C36.219 46.6796 31.5247 50.4073 27.9048 55L21 50.0703Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmartGatewayIcon);
export default __webpack_public_path__ + "static/media/SmartGateway_Icon.e98af71a399c7d7c76da20ac3be64b6a.svg";
export { ForwardRef as ReactComponent };